import { PRICE_TYPES } from '@bytel/bytel-sales';

export class PriceTypeUtils {
    public static priceTypeSimToEnum(type: string): PRICE_TYPES {
        switch (type) {
            case 'IMMEDIAT':
                return PRICE_TYPES.Today;
            case 'MENSUEL':
                return PRICE_TYPES.EveryMonth;
            case 'DIFFERE':
                return PRICE_TYPES.Reported;
            case 'AUTRE':
                return PRICE_TYPES.Other;
            default:
                break;
        }
    }
}
